export default __webpack_public_path__ + "static/artwork-logo-f4306da046e33a94f86404c0c181e167.png";